import { toCurrency } from './format.util';

export function hasConfig(card) {
  return Boolean(card.alertBelowPrice || card.alertAbovePrice);
}

export function hasAlert(card) {
  const alertPriceDecrease = typeof card.alertBelowPrice === 'number'
    && typeof card.currentValue === 'number'
    && card.currentValue < card.alertBelowPrice;

  const alertPriceIncrease = typeof card.alertAbovePrice === 'number'
    && typeof card.currentValue === 'number'
    && card.currentValue > card.alertAbovePrice;

  return alertPriceDecrease || alertPriceIncrease;
}

export function getAlertIcon(card) {
  if (hasAlert(card)) {
    return 'notification_important';
  }

  if (hasConfig(card)) {
    return 'notifications_active';
  }

  return 'notifications_none';
}

export function getAlertText(card) {
  if (!hasConfig(card)) {
    return 'Setup pricing alerts for this card';
  }

  let text;

  if (hasAlert(card)) {
    const alertPriceDecrease = card.currentValue < card.alertBelowPrice;

    text = `This card is valued at ${toCurrency(card.currentValue)}, ${alertPriceDecrease ? 'below' : 'above'} your threshold of ${toCurrency(alertPriceDecrease ? card.alertBelowPrice : card.alertAbovePrice)}!`;
  } else {
    text = 'Alert me when the value ';

    if (card.alertBelowPrice) {
      text += `drops below ${toCurrency(card.alertBelowPrice)}`;
    }

    if (card.alertBelowPrice && card.alertAbovePrice) {
      text += ' or ';
    }

    if (card.alertAbovePrice) {
      text += `goes above ${toCurrency(card.alertAbovePrice)}`;
    }
  }

  return text;
}

export function constructWatchCard(uid, card) {
  return {
    cardId: card.cardId || card.id,
    uid,
    category: card.category || '',
    condition: card.condition || '',
    currentValue: card.stats && card.stats.currentValue ? card.stats.currentValue : null,
    score: card.stats && card.stats.score ? card.stats.score : null,
    priceMovement: card.stats && card.stats.priceMovement ? card.stats.priceMovement : 0,
    monthlyPercentChange: card.stats && card.stats.monthlyPercentChange ? card.stats.monthlyPercentChange : null,
    image: card.image || '',
    label: card.label || '',
    player: card.player || '',
    year: card.year || '',
    set: card.set || '',
    variation: card.variation || '',
    number: card.number || '',
    pop: card.pop || null,
  };
}
